import { useIntl } from 'react-intl';
import MainCard from '@/components/base-component/MainCard';
import Form from '../form';
import { ITypeOnSave, ITypeAccount } from '../../../type';
import useApiCreate from '@/hooks/useApiCreate';
import { Modal, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import useApiUpdate from '@/hooks/useApiUpdate';
import useAlert from '@/hooks/useAlert';
import { openSnackbar } from '@/api/snackbar';
import { SnackbarProps } from '@/types/bs-types/snackbar';

export default function EditModal({
  onClose,
  data,
  open = false,
  onSuccess,
  onFailure
}: {
  open?: boolean;
  onClose: () => void;
  data?: ITypeAccount;
  onSuccess?: () => void;
  onFailure?: () => void;
}) {
  const { showAlert } = useAlert();
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const { handleUpdate: handleUpdateAccount } = useApiUpdate(`/account/${data?.id}`);
  const { handleCreate: handleCreateAccount } = useApiCreate(`/account`);
  const { handleCreate: handleUploadAvatar } = useApiCreate('/upload/avatar');

  const confirmSaveAPI = (data: ITypeOnSave) => {
    showAlert({
      type: 'Confirm',
      title: 'ยืนยันการแก้ไข',
      message: 'เมื่อกด ตกลง ข้อมูลดังกล่าวจะถูกบันทึก',
      confirmButtonColor: theme.palette.primary.main,
      onCancel() {},
      onConfirm() {
        onSave(data);
      }
    });
  };

  const [datas, setDatas] = useState<ITypeAccount>();

  useEffect(() => {
    const newformat = {
      ...data
    };
    setDatas(newformat);
  }, [data]);

  const onSave = async (data: ITypeOnSave) => {
    let avatar = data?.account?.avatar;

    if (data?.selectedImage) {
      const formData = new FormData();
      formData.append('file', data?.selectedImage);
      formData.append('displayName', `avatar-${data?.account?.email}-${new Date().getTime()}`);
      const resAvatar = await handleUploadAvatar(formData);

      if (resAvatar?.payload) {
        avatar = resAvatar?.payload?.path;
      }
    }

    if (data?.type === 'edit') {
      const res = await handleUpdateAccount({ ...data.account, avatar });

      if (res.error) {
        openSnackbar({
          open: true,
          message: `${formatMessage({ id: 'snackbar.update.error' })}`,
          variant: 'alert',
          alert: {
            color: 'error'
          }
        } as SnackbarProps);
      } else {
        openSnackbar({
          open: true,
          message: `${formatMessage({ id: 'snackbar.update.success' })}`,
          variant: 'alert',
          alert: {
            color: 'success'
          }
        } as SnackbarProps);
      }
    } else {
      const res = await handleCreateAccount({ ...data.account, avatar });

      if (res.error) {
        openSnackbar({
          open: true,
          message: `${formatMessage({ id: 'snackbar.create.error' })}`,
          variant: 'alert',
          alert: {
            color: 'error'
          }
        } as SnackbarProps);
      } else {
        openSnackbar({
          open: true,
          message: `${formatMessage({ id: 'snackbar.create.success' })}`,
          variant: 'alert',
          alert: {
            color: 'success'
          }
        } as SnackbarProps);
      }
    }

    onSuccess?.();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <MainCard sx={{ maxWidth: 800 }} title="แก้ไขผู้ใช้งาน" modal darkTitle content={false}>
        <Form onSave={confirmSaveAPI} onClose={onClose} data={datas} />
      </MainCard>
    </Modal>
  );
}
